
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap').default;
require('./utilities/event').default;
require('./utilities/countries').default;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import MyCalculations from './views/MyCalculations'
import Routes from './routes.js'

Vue.component('Home', require('./views/Home.vue').default);
Vue.component('FeedTable', require('./components/Feed.vue').default);
Vue.component('Animal', require('./views/Animal.vue').default);
Vue.component('Accessibility', require('./views/Accessibility.vue').default);
Vue.component('matrix', require('./components/Matrix.vue').default);
Vue.component('product', require('./views/Product.vue').default);
Vue.component('step', require('./components/Step.vue').default);
Vue.component('custom-modal', require('./components/Modal.vue').default);
Vue.component('my-calculations', MyCalculations);
Vue.component('calcium', require('./components/Calcium.vue').default);

import { country_list } from './utilities/countries.js';

window.EventHub = new Vue();

const app = new Vue({
    el: '#calc-app',
    router: Routes,
    data: {
        countries: country_list,
        selectedCountry: '',
        appEnv: process.env.MIX_APP_ENV
    }
});

// const register = new Vue({
//     el: '#register',
// });

// const nav = new Vue({
//     el: '#calc-navbar',
// });
